import { Element, Transforms, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, BookmarkElement as BookmarkElementType } from 'slate/types/slate';
import { getAllLinks } from '../link';
import { BookmarkElement } from './components/BookmarkElement';

const isBookmark = (node: Node): node is BookmarkElementType => Element.isElement(node) && node.type === 'bookmark';

const withBookmarks =
  (options: { deleteBookmark?: (a: { id?: string; documentSuperId?: string }) => void; documentId?: string } = {}) =>
  (editor: CustomEditor) => {
    const { isInline, renderElement, normalizeNode } = editor;
    const { deleteBookmark, documentId } = options;
    editor.isInline = (element: CustomElement) => isBookmark(element) || isInline(element);

    editor.renderElement = (props: RenderElementProps) => {
      if (isBookmark(props.element)) {
        return <BookmarkElement {...props} />;
      } else {
        return renderElement(props);
      }
    };
    editor.normalizeNode = (entry) => {
      const [node, path] = entry;

      if (isBookmark(node)) {
        if (Node.string(node) === '') {
          const links = getAllLinks(editor);
          const matchedLinks = links.filter((link) => link.bookmarkId === node.id);
          matchedLinks.forEach((link) => {
            Transforms.unwrapNodes(editor, { at: link.path });
          });
          deleteBookmark?.({ id: node.id, documentSuperId: documentId });
          Transforms.unwrapNodes(editor, { at: path });
          return;
        }
      }

      normalizeNode(entry);
    };
    return editor;
  };

export default withBookmarks;
